import $ from 'jquery';

export default {
  init() {
    this.addEvents();
    this.modifyDOM();
  },

  addEvents() {
    $(document).on('click', '.woocommerce-message .close-button', this.onCloseNotice);
    $(document).on('click', '.woocommerce-info .close-button', this.onCloseNotice);
    $(document).on('click', '.woocommerce-error .close-button', this.onCloseError);
  },

  onCloseError() {
    $(this).parent().parent().remove();
  },
  onCloseNotice() {
    $(this).parent().remove();
  },


  modifyDOM() {
    $('#drager-form-coupon-holder').css('visibility', 'hidden');
    $('#kco-extra-checkout-fields').css('display', 'none');
    $('#klarna-checkout-container').css('visibility', 'hidden');
    $('#kco-iframe .checkout-header').html('Betalning (Fyll i serienummer för att fortsätta)');

    $('#kco-extra-checkout-fields').css('display', 'none');

    $('#serial_number').bind('keypress keyup blur', function () {
      var pattern = /(\w{4})-(\d{4})/gi
      if (pattern.test($(this).val())) {
        $('#kco-iframe .checkout-header').html('Betalning');
        $('#drager-form-coupon-holder').css('visibility', 'visible');
        $('#klarna-checkout-container').css('visibility', 'visible');
        $('.serial-match-error').hide();

        console.log($(this).val());
        $('#hidden_serial_number').val($(this).val());
      } else {
        $('#kco-iframe .checkout-header').html('Betalning (Fyll i serienummer för att fortsätta)');
        $('#klarna-checkout-container').css('visibility', 'hidden');
        $('#drager-form-coupon-holder').css('visibility', 'hidden');
        $('.serial-match-error').show();
      }
    });

    $('#coupon_code_mirror').bind('keypress keyup blur', function () {
      $('#coupon_code').val($(this).val());
    });
    $('#apply_coupon_mirror').click((e) => {
      e.preventDefault();
      $('#apply_coupon').click();
    });
    
    setTimeout(() => {
      $('#kco-order-review,#klarna-checkout-container ,.woocommerce-order-details').addClass('checkout-arrow');
      $('.woocommerce-order-received').find('#klarna-checkout-container').hide();
    }, 300);

  },
};
